import { Component, OnInit, Inject, ViewEncapsulation, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlService } from '../../services/control.service';
import { mouseProjection } from '../../interfaces/app-config'
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';
import { ToggleEventNameType, ToggleEventService, ToggleEventType } from '@tt-lib/services/toggle-event.service';
import { BackEventService } from '@tt-lib/services/back-event.service';

@Component({
  // encapsulation: ViewEncapsulation.None,
  selector: 'tt-mouse-position',
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    TranslateModule
  ],
  templateUrl: './mouse-position.component.html',
  styleUrls: ['./mouse-position.component.scss'],
  standalone: true
})

export class MousePositionComponent implements OnInit, OnDestroy {
  projections: mouseProjection[];
  projection: mouseProjection;
  name: string;
  private backEventSubscription: Subscription = null;

  //@ViewChild(MatMenuTrigger) projectionTriggerBtn!: MatMenuTrigger;
  @ViewChild("projectionTriggerBtn") projectionTriggerBtn!: MatMenuTrigger;

  constructor(
    public controlService: ControlService,
    private toggleEventService: ToggleEventService,
    private backEventService: BackEventService
  ) {
  }

  ngOnInit() {
    this.controlService.initMouseProjections().subscribe(_ => {
      this.projections = this.controlService.getProjections();
      this.controlService.attachMouseTracking('main');
    });    
    // this.controlService.attachMouseTracking('splitviewMap');
  }

  ngOnDestroy(): void {
    this.controlService.detachAllTracking()
    this.backEventSubscription?.unsubscribe();
  }

  setProjection(projection: mouseProjection) {
    this.controlService.setMousePositionProjection(projection);
  }

  menuOpened() {
    if (!this.backEventSubscription) {
      this.backEventSubscription = this.toggleEventService.emitter$.subscribe(
        (toggleEvent: ToggleEventType) => {
          if (toggleEvent.forwardedFor === 'mouse-position' && toggleEvent.eventName === ToggleEventNameType.CLOSE_COMMAND) {
            this.projectionTriggerBtn.closeMenu();
          }
        }
      );
    }
    this.backEventService.registerOpenedWindow({ windowName: 'mouse-position', isAutoCloseableWindow: false });
  }
}